import { useRef } from "react";
import ORPotvrda from "../../../..//assets/potvrdeIDiplome/orPotvrda.pdf";
import Icon from "../../../../assets/img/PDFIcon.png";
import RarPor from "../../../../assets/potvrdeIDiplome/potvrdaRar.pdf";
import { makePDFCertificate } from "../Supervizije/CertificateContainer/makePDFCertificate";
import { handleDownload } from "../Supervizije/CertificateContainer/utils";
import styles from "./DiplomePotvrde.module.css";
import {
  polaznikOR1DiplomePotvrde,
  polaznikRARDiplomePotvrde,
  polaznikTT5DiplomePotvrde,
} from "./MockData";

function DiplomePotvrde({ userId, polaznikLevel, name, programs }) {
  let dataToRender = [];
  if (polaznikLevel === "rar") {
    dataToRender = polaznikRARDiplomePotvrde;
  } else if (polaznikLevel === "praktičar") {
    dataToRender = polaznikOR1DiplomePotvrde;
  } else if (polaznikLevel === "psihoterapeut") {
    dataToRender = polaznikTT5DiplomePotvrde;
  }
  const programi = dataToRender.map((item) => item.programi).flat();
  const canvasRef = useRef(null);
  return (
    <div className={styles.raniRazvojPrvaSekcija2}>
      <h1 className={styles.raniRazvojHeader}>Diplome i potvrde</h1>
      <p className={styles.raniRazvojDescription}>
        Kad svi uvjeti za stjecanje potvrde/diplome budu zadovoljeni, moći ćeš
        je preuzeti ovdje.
      </p>
      <div className={styles.potvrdeWrapper}>
        <canvas
          ref={canvasRef}
          width={850}
          height={1000}
          style={{ display: "none" }}
        />
        <span className={styles.title}>Potvrda o završenom programu ITP-a</span>
        {programi[0].isRARPolozen ? (
          <>
            <div className={styles.programRow}>
              <img alt="" src={Icon} className={styles.icon} />
              <span className={styles.label}>
                Potvrda o završenom RAR programu
              </span>
            </div>
            <button
              className={styles.potvrdaBtn}
              onClick={() =>
                handleDownload(
                  makePDFCertificate,
                  RarPor,
                  name,
                  `rar-potvrda`,
                  "rar"
                )
              }
            >
              Preuzmi potvrdu
            </button>
          </>
        ) : (
          <span className={styles.raniRazvojDescription}>
            Tvoja potvrda o završenom programu RAR još uvijek nije u izradi.
          </span>
        )}
        {programs.find((id) => id === 6 || id === 10) ? (
          <>
            <div className={styles.programRow}>
              <img alt="" src={Icon} className={styles.icon} />
              <span className={styles.label}>
                Potvrda o završenom OR programu
              </span>
            </div>
            <button
              className={styles.potvrdaBtn}
              onClick={() =>
                handleDownload(
                  makePDFCertificate,
                  ORPotvrda,
                  name,
                  `or-potvrda`,
                  "or"
                )
              }
            >
              Preuzmi potvrdu
            </button>
          </>
        ) : (
          <span className={styles.raniRazvojDescription}>
            Tvoja potvrda o završenom programu OR još uvijek nije u izradi.
          </span>
        )}

        {programi[0].isTTPolozen ? (
          <>
            <div className={styles.programRow}>
              <img alt="" src={Icon} className={styles.icon} />
              <span className={styles.label}>
                Potvrda o završenom TT programu
              </span>
            </div>
            <button
              className={styles.potvrdaBtn}
              // onClick={() => generateDegree("TT")}
            >
              Preuzmi potvrdu
            </button>
          </>
        ) : (
          <span className={styles.raniRazvojDescription}>
            Tvoja potvrda o završenom programu TT još uvijek nije u izradi.
          </span>
        )}
      </div>
      {polaznikLevel !== "rar" && (
        <div className={styles.potvrdeWrapper}>
          <span className={styles.title}>Diploma ITP-a</span>
          {dataToRender[0].isPrakticarDiplomaReady ? (
            <>
              <div className={styles.programRow}>
                <img alt="" src={Icon} className={styles.icon} />
                <span className={styles.label}>Praktičar ITP-a</span>
              </div>
              <button
                className={styles.potvrdaBtn}
                // onClick={() => generateDegree("ITP")}
              >
                Preuzmi potvrdu
              </button>
            </>
          ) : (
            <span className={styles.raniRazvojDescription}>
              Tvoja potvrda o statusu Praktičara ITP-a još uvijek nije u izradi.
            </span>
          )}
          {dataToRender[0].isTerapeutDiplomaReady ? (
            <>
              <div className={styles.programRow}>
                <img alt="" src={Icon} className={styles.icon} />
                <span className={styles.label}>Psihoterapeut ITP-a</span>
              </div>
              <button className={styles.potvrdaBtn}>Preuzmi diplomu</button>
            </>
          ) : (
            <span className={styles.raniRazvojDescription}>
              Tvoja diploma o zvanju Psihoterapeuta ITP-a još uvijek nije u
              izradi.
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export default DiplomePotvrde;
